import * as React from 'react';
import * as HttpStatus from 'http-status-codes';
import { Error } from 'components/error/Error';
import { Loader } from 'components/loader/Loader';
import { STATUSES } from 'core/api';
import Article from './components/Article/Article';
import Category from './components/Category/Category';
import Hashtags from './components/Hashtags/Hashtags';
import { extendQueryString } from './helpers';
import { ICategoryData, IProps } from './interfaces';
import { useAppSelector } from 'core/store/createStore';

const Content: React.FC<IProps> = ({
  match: {
    params: { locale },
  },
  history,
  location,
}) => {
  const {
    status: contentStatus,
    error: contentError,
    data: contentData,
  } = useAppSelector(state => state.content);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    newPage: number,
  ) => {
    const { pagination } = contentData.data as ICategoryData;
    history.push(
      `${location.pathname}${extendQueryString(location.search, {
        limit: pagination.limit,
        page: newPage,
      })}${location.hash}`,
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    history.push(
      `${location.pathname}${extendQueryString(location.search, {
        limit: event.target.value,
        page: 0,
      })}${location.hash}`,
    );
  };

  const renderComponent = () => {
    switch (contentData.data.type) {
      case 'article':
        return <Article data={contentData.data} />;
      case 'category':
        return (
          <Category
            data={contentData.data}
            locale={locale}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        );
      case 'hashtags':
        return (
          <Hashtags
            data={contentData.data}
            locale={locale}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        );
      default:
        return null;
    }
  };

  switch (contentStatus) {
    case STATUSES.REQUEST:
      return <Loader />;
    case STATUSES.SUCCESS:
      return renderComponent();
    case STATUSES.FAILED:
      if (contentError === String(HttpStatus.NOT_FOUND)) {
        return <Error>PAGE NOT FOUND</Error>;
      }

      return <Error>{contentError || 'Error'}</Error>;
    default:
      return null;
  }
};

export default React.memo(Content);
